import { BasicStyledComponent } from 'shared-definitions/types'
import Like from 'shared-svg/ThumbUp2.svg'
import styles from './ButtonReaction.module.css'
import clsx from 'clsx'

interface ButtonReactionProps extends BasicStyledComponent {
  variant: 'like' | 'dislike'
  disabled?: boolean
  selected?: boolean
  onClick?: () => void
}

const ButtonReaction: React.FC<ButtonReactionProps> = ({
  disabled,
  selected,
  variant,
  className,
  onClick,
}) => (
  <button
    type="button"
    className={clsx(styles.container, className, {
      [styles.variantLike]: variant === 'like',
      [styles.variantDislike]: variant === 'dislike',
      [styles.selected]: selected,
      [styles.disabled]: disabled,
    })}
    onClick={() => {
      onClick?.()
    }}
  >
    <Like className={styles.icon} />
  </button>
)

export default ButtonReaction
